import { render, staticRenderFns } from "./PaymentWechat.vue?vue&type=template&id=5aa7046f&scoped=true"
import script from "./PaymentWechat.vue?vue&type=script&lang=js"
export * from "./PaymentWechat.vue?vue&type=script&lang=js"
import style0 from "./PaymentWechat.vue?vue&type=style&index=0&id=5aa7046f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa7046f",
  null
  
)

export default component.exports